import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { JobCanOrderData } from '../models/job-can-order-data.model';
import { JobItem } from '../models/job-item.model';
import { JobWithQuotes } from '../models/job-with-quotes.model';
import { CanOrderForJobGQL } from '../queries/can-order-for-job.query';
import { JobQuotesListByJobKeyGQL } from '../queries/job-quotes-list.query';
import { JobsListByNameGQL } from '../queries/jobs-list.query';

@Injectable({
  providedIn: 'root',
})
export class JobService {
  private readonly jobsListByNameGQL = inject(JobsListByNameGQL);
  private readonly jobQuotesListByJobKeyGQL = inject(JobQuotesListByJobKeyGQL);
  private readonly canOrderForJobGQL = inject(CanOrderForJobGQL);

  getJobsByName(input: string, take = 100): Observable<JobItem[]> {
    return this.jobsListByNameGQL
      .fetch({ search: input, take }, { fetchPolicy: 'network-only' })
      .pipe(map((response) => response.data?.jobs.items));
  }

  getJobWithQuotes(jobKey: string): Observable<JobWithQuotes> {
    return this.jobQuotesListByJobKeyGQL
      .fetch({ jobKey }, { fetchPolicy: 'network-only', errorPolicy: 'all' })
      .pipe(map((response) => response.data.job));
  }

  canOrderForJob(jobKey: string): Observable<JobCanOrderData> {
    return this.canOrderForJobGQL
      .fetch({ jobKey }, { fetchPolicy: 'network-only', errorPolicy: 'all' })
      .pipe(map((response) => response.data.canOrderForJob));
  }
}
